import { Col, Row } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { ButtonC, SelectC } from "src/shared/components";
import fileDownloader from "src/shared/function/fileDownloader";
import useAuth from "src/shared/hooks/useAuth";
import useDomain from "src/shared/hooks/useDomain";
import useLocalization from "src/shared/hooks/useLocalization";
import "./index.less";

const HeaderWhiteLable2 = () => {
  const { t } = useTranslation();
  const { logoPath, primaryColor } = useDomain();
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint();
  const { isLogedIn, decode, accessToken, logout } = useAuth();
  const { getLanguage, setLanguage } = useLocalization();

  const {
    push,
    location: { search },
  } = useHistory();

  return (
    <Row justify="center" align="middle" className="HeaderWhiteLable2">
      <Col className="mainCol" span={24}>
        <Row justify="space-between" style={{ height: "100%" }} align="middle">
          <Col>
            <Row justify="start" align="middle" gutter={[20, 0]}>
              <Col>
                <img className="logo" src={fileDownloader(logoPath)} alt="" />
              </Col>
              <Col>
                <Link to={`/public`}>
                  <span className="spanMenu">{t("Home")}</span>
                </Link>
              </Col>
              <Col>
                <Link to={`/public/services`}>
                  <span className="spanMenu">{t("Services")}</span>
                </Link>
              </Col>
              <Col>
                <Link to={`/public/api`}>
                  <span className="spanMenu">{t("API")}</span>
                </Link>
              </Col>
              <Col>
                <SelectC
                  showSearch
                  size="small"
                  className="spanMenu"
                  style={{
                    width: "120px",
                    transform: "translate(0,12px)",
                  }}
                  bordered={false}
                  // col={{ xs: 24 }}
                  defaultValue={
                    getLanguage()?.language ||
                    // @ts-ignore
                    JSON.parse(localStorage.getItem("localization"))?.language
                  }
                  api="/localization/languages/select"
                  formItem={{
                    label: "",
                    name: "language",
                  }}
                  onChange={(e, r) => {
                    //@ts-ignore
                    setLanguage(e, r?.row?.iso639_1, r?.row?.isRtl);
                    window.location.reload();
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <ButtonC
              type="default"
              style={{
                borderRadius: "10px",
                border: "1px solid #201D35",
                padding: "0 20px",
              }}
            >
              {t("login")}
            </ButtonC>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HeaderWhiteLable2;
